import { Box, Stack, Typography } from '@mui/material';
import { IPayslips } from 'API/Paychecks/paychecks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { AddCommaToNumber } from 'Utils/AddCommaToNumber';

interface IPaychecksDetails {
  currentPaycheck: IPayslips | null;
  showPaychecks: boolean;
}

export const PaychecksDetails = ({
  currentPaycheck,
  showPaychecks,
}: IPaychecksDetails) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userPaychecks;

  return (
    <Stack
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-around'}
      sx={{ mt: 2, width: '100%', height: '47px' }}
    >
      <Stack
        flexDirection={'column'}
        justifyContent={'space-around'}
        alignItems={'center'}
        sx={{ width: '100%' }}
      >
        {showPaychecks && (
          <Typography variant='body2'>
            {AddCommaToNumber(currentPaycheck?.deduction)} ₪
          </Typography>
        )}
        <Stack
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Box
            sx={{
              width: '8px',
              height: '8px',
              borderRadius: '25px',
              bgcolor: '#A3D7D4',
              mr: '8px',
            }}
          />
          <Typography variant='body6'>{dictionary.deductions}</Typography>
        </Stack>
      </Stack>
      <Stack
        flexDirection={'column'}
        justifyContent={'space-around'}
        alignItems={'center'}
        sx={{ width: '100%' }}
      >
        {showPaychecks && (
          <Typography variant='body2'>
            {AddCommaToNumber(currentPaycheck?.net)} ₪
          </Typography>
        )}
        <Stack
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Box
            sx={{
              width: '8px',
              height: '8px',
              borderRadius: '25px',
              bgcolor: '#008F88',
              mr: '8px',
            }}
          />
          <Typography variant='body6'>
            {dictionary.transferToYourAccount}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
